import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI } from '../../../types/default-cloud-graph-space-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { ForgePioClickupIcon, ForgePioClickupSearchResultIcon } from './icon';

export const forgePioClickupConfig: ThirdPartyConfig = {
	displayName: 'Clickup by Pio',
	id: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
	resourceType: ProductResourceTypes3P.ForgePioClickupProd,
	icon: get3PLogo(ForgePioClickupIcon, 'ForgePioClickup', 'medium'),
	searchResultIcon: get3PLogo(ForgePioClickupSearchResultIcon, 'ForgePioClickup', 'large'),
	integrationAri: 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Space,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
